import { createFileRoute, Outlet } from '@tanstack/react-router'
import { MatterportWalkthrough } from 'pages/matterport/MatterportWalkthrough'
import { DEFAULT_DOCUMENT_TITLE } from 'utils/documentTitle'

import { walkthroughSearchParams } from './-searchParams'

const RouteComponent = () => {
  const { siteId } = Route.useSearch()

  if (!siteId) {
    return <Outlet />
  }

  return <MatterportWalkthrough siteId={siteId} />
}

export const Route = createFileRoute('/walkthrough/')({
  component: RouteComponent,
  validateSearch: walkthroughSearchParams,
  staticData: {
    title: `${DEFAULT_DOCUMENT_TITLE} Walkthrough`,
  },
})
